<template lang="pug">
  v-container.View.View--CompanyLocationCreate
    template(v-if="!loading")
      v-card.pa-3
        LocationEditor(:location="location" :categories="categories" @save="create" :saving="saving")
      HelpAlert.mt-3
    template(v-else)
      Loading
</template>

<script>
import Loading from "@/components/Loading";
import HelpAlert from "@/components/HelpAlert";
import LocationEditor from "./LocationEditor";
import Category from "@/api/Category";
import Location from "@/api/Location";

function makeOpeningHours() {
  const openingHours = [];
  for (const i of [0, 1, 2, 3, 4, 5, 6]) {
    openingHours.push({
      weekday: i,
      slots: [
        { from: null, to: null },
        { from: null, to: null }
      ]
    });
  }
  return openingHours;
}

export default {
  name: "CompanyLocationCreate",
  components: { Loading, LocationEditor, HelpAlert },
  data() {
    return {
      loading: true,
      saving: false,
      location: {
        openingHours: makeOpeningHours()
      },
      categories: []
    };
  },

  async mounted() {
    this.loading = true;
    this.$emit("update:title", "Aggiungi Attività");
    this.categories = await Category.all();
    this.loading = false;
  },

  methods: {
    async create(location) {
      this.saving = true;
      try {
        await Location.create(location);
      } catch (error) {
        this.saving = false;
        throw error;
      }
      this.saving = false;
      this.$router.replace({
        name: "company.location.list"
      });
    }
  }
};
</script>
